import {
	type Dispatch,
	type SetStateAction,
	useEffect,
	useRef,
	useState,
} from "react";

export const useResetOnOpen = <T>(open: boolean, initial: T) => {
	const [value, setValue] = useState(initial);
	const wasOpenRef = useRef(open);
	const latestInitialRef = useRef(initial);
	latestInitialRef.current = initial;

	useEffect(() => {
		const wasClosed = !wasOpenRef.current;
		wasOpenRef.current = open;
		if (open && wasClosed) setValue(latestInitialRef.current);
	}, [open]);

	return [value, setValue] as [T, Dispatch<SetStateAction<T>>];
};
